import React from 'react'
import { AgTechStepModalProps } from '@agtech/web/components/Portals/Modals/AgTechStepModal'
import LogoUpdateForm from '@agtech/web/integrations/operation/logo/forms/OperationLogoUpdateForm'
import SaleDiscountViewGrid from './areas/discounts/components/grids/SaleDiscountViewGrid'
import { SaleDiscountDataProvider } from '@sales/data/sales/discounts/SaleDiscountDataQueries'
import LotCategoryGrid from './areas/lotCategories/components/grids/LotCategoryGrid'
import ContactImportModal from '@agtech/web-imports/integrations/ContactImportModal'

const SalesAppSetupModal: AgTechStepModalProps = {
    name: 'Setup your application',
    height: '600px',
    width: '1200px',
    steps: [
        {
            name: 'Upload Your Logo',
            description: 'If your operation has a logo, upload it here. This logo will be used on your invoices and other documents.',
            content: () => <OperationSetupUploadLogoPage />
        },
        { 
            name: 'Import Contacts',
            description: "Use the button below to import your operation's contact list as a .csv or .xlsx file. If you don't have a file available, please continue. Contacts can be imported or updated at a later time.",
            content: () => <OperationSetupImportContactsPage />
        },
        {
            name: 'Enter Sale Discounts',
            description: 'Sale discounts can be applied to lot sales during invoicing. If you are not ready to input your discounts right now, please continue. Sale discounts can be updated at any time.',
            content: () => <OperationSetupInputSaleDiscountsPage />
        },
        {
            name: "Enter Lot Categories",
            description: 'Lot categories help in visualizing, grouping, and filtering the lots in your sale If you are not ready to input your categories right now, please continue. Lot categories can be updated at any time.',
            content: () => <OperationSetupInputLotCategoryPage />
        }
    ],
    onComplete: () => {

    }
}

const OperationSetupUploadLogoPage = () => {
    return (
        <div className='stretched row-based container'>
            <LogoUpdateForm />
        </div>
    )
}

const OperationSetupImportContactsPage = () => {
    return (
        <div className='flexed row-based centered container'>
            <ContactImportModal.Button classes='button-highlight'/>
        </div>
    )
}

const OperationSetupInputSaleDiscountsPage = () => {
    return (
        <div className='stretched row-based container'>
            <SaleDiscountDataProvider>
                {(discounts) => {
                    return (
                        <SaleDiscountViewGrid discounts={discounts} />
                    )
                }}
            </SaleDiscountDataProvider>
        </div>
    )
}

const OperationSetupInputLotCategoryPage = () => {
    return (
        <div className='stretched row-based container'>
            <LotCategoryGrid />
        </div>
    )
}

export default SalesAppSetupModal